import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MomentModule } from 'ngx-moment';

import { CourseReserveDatesComponent } from './course-reserve-dates.component';

@NgModule({
  imports: [CommonModule, MomentModule],
  declarations: [CourseReserveDatesComponent],
  exports: [CourseReserveDatesComponent],
})
export class CourseReserveDatesModule {}
